"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { Toaster as Sonner } from "sonner";
export const Toaster = ({ type, ...props })=>{
    if (type === "live") {
        return /*#__PURE__*/ _jsx(Sonner, {
            theme: "dark",
            className: "toaster group",
            gap: 8,
            mobileOffset: {
                bottom: 45
            },
            toastOptions: {
                style: {
                    backgroundColor: "rgba(35, 39, 46, 0.7)",
                    backdropFilter: "blur(24px)",
                    color: "#FFFFFF",
                    borderRadius: "200px",
                    border: "1px solid rgba(255, 255, 255, 0.1)",
                    boxShadow: "5px 5px 9px 0px rgba(0,0,0,0.24)"
                }
            },
            ...props
        });
    }
    return /*#__PURE__*/ _jsx(Sonner, {
        theme: "dark",
        className: "toaster group",
        gap: 8,
        // offset={{ right: 425, top: 80 }} top right
        offset: {
            top: 70
        },
        mobileOffset: {
            top: 70
        },
        toastOptions: {
            style: {
                userSelect: "none",
                backdropFilter: "blur(24px)",
                backgroundColor: "rgba(35, 39, 46, 0.8)",
                color: "#FFFFFF",
                borderRadius: "14px",
                border: "1px solid rgba(255, 255, 255, 0.1)",
                boxShadow: "5px 5px 9px 0px rgba(0,0,0,0.24)"
            }
        },
        ...props
    });
};
